import { render, staticRenderFns } from "./sec-alianzas.vue?vue&type=template&id=c546c53c&scoped=true&"
import script from "./sec-alianzas.vue?vue&type=script&lang=js&"
export * from "./sec-alianzas.vue?vue&type=script&lang=js&"
import style0 from "./sec-alianzas.vue?vue&type=style&index=0&id=c546c53c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c546c53c",
  null
  
)

export default component.exports